/**
 * Access Control Better Auth (Frontend)
 * Debe coincidir con el backend: admin · planta · tienda
 */

import { createAccessControl } from 'better-auth/plugins/access'
import { adminAc, defaultStatements } from 'better-auth/plugins/admin/access'

export const statement = defaultStatements

export const ac = createAccessControl(statement)

export const admin = ac.newRole({
  ...adminAc.statements
})

export const planta = ac.newRole({
  session: []
})

export const tienda = ac.newRole({
  session: []
})

export const roles = {
  admin,
  planta,
  tienda
}

export type RoleName = keyof typeof roles

export const ROLE_LABELS: Record<RoleName, string> = {
  admin: 'Administrador',
  planta: 'Planta',
  tienda: 'Tienda'
}

/** Roles con acceso a catálogo/maestros (alineado con CATALOG_ROLES del backend). */
export const CATALOG_ROLE_NAMES: RoleName[] = ['admin', 'planta']

export function canAccessCatalog(role: string | null | undefined): boolean {
  return role === 'admin' || role === 'planta'
}
